module.exports = __webpack_public_path__ + "img/sidebar-app-ico-wht-01.c6c95b56.svg";